import common from './common'
import newRequest from './newRequest'
import requestHeader from '../utils/requestHeader'

export const filterEmpty = (data, validation) => {
  if (typeof data !== 'object') return {}
  const newObj = {}
  for (const key of Object.keys(data)) {
    if (!validation) {
      if (data[key] !== '' && data[key] !== undefined && data[key] !== null) {
        newObj[key] = data[key]
      }
    } else {
      if (!validation.includes(data[key])) {
        newObj[key] = data[key]
      }
    }
  }
  return newObj
}

export const downloadFile = (data, type, filename = 'download') => {
  const blob = new Blob([data], { type })
  const objectUrl = URL.createObjectURL(blob)
  let elA = document.createElement('a')
  elA.href = objectUrl
  elA.download = filename
  // elA.click();
  // 下面这个写法兼容火狐
  elA.dispatchEvent(
    new MouseEvent('click', { bubbles: true, cancelable: true, view: window })
  )
  elA = null
  window.URL.revokeObjectURL(objectUrl)
}

/**
 * 导出excel
 */
export const downloadExcelFile = async (
  url,
  filename,
  params,
  method = 'POST'
) => {
  const afterParams = filterEmpty(params)
  if (afterParams.currentPage) {
    delete afterParams.currentPage
  }
  return new Promise(async (resolve, reject) => {
    const data = await newRequest({
      url,
      method,
      headers: requestHeader.createHeaders(afterParams),
      responseType: 'blob',
      params: afterParams,
    })
    if (!data) {
      reject()
      return
    }
    downloadFile(data, 'blob', filename)
    resolve()
  })
}

export const currency = (value, digits = 2) => {
  if (!value) {
    if (digits === 0) {
      return '0'
    } else {
      return '0.00'
    }
  }
  // 货币格式, 并保留2位小数
  const nv = Number(String(value).replace(/[^\d.-]/g, '')).toFixed(digits) + ''
  const l = nv.split('.')[0].split('').reverse()
  const r = nv.split('.')[1]
  let t = ''
  for (let i = 0; i < l.length; i++) {
    t += l[i] + ((i + 1) % 3 === 0 && i + 1 !== l.length ? ',' : '')
  }
  if (r) {
    return t.split('').reverse().join('') + '.' + r
  } else {
    return t.split('').reverse().join('')
  }
}

export default {
  common: common,
  filterEmpty,
}
